import {
  Author1,
  Author2,
  Author3,
  Author4,
  Author5,
  Author6,
  Course1,
  Course2,
  Course3,
  Course4,
  Course5,
  Course6,
} from "../assets";

export const courses = [
  {
    id: 1,
    courseImg: Course1,
    track: "Design",
    likes: "32.7k+",
    title: "introduction to user research in ux design",
    duration: "23hrs 50mins",
    lesson: "15 lessons",
    authorImg: Author1,
    author: "leonard victor",
    price: 15,
  },
  {
    id: 2,
    courseImg: Course2,
    track: "Marketing",
    likes: "8.7k+",
    title: "introduction to  new marketing audience ",
    duration: "22hrs 30mins",
    lesson: "22 lessons",
    authorImg: Author2,
    author: "Jeffrey williams",
    price: 32,
  },
  {
    id: 3,
    courseImg: Course3,
    track: "Development",
    likes: "12.7k+",
    title: "introduction to html, css & bootstrap",
    duration: "45hrs 50mins",
    lesson: "55 lessons",
    authorImg: Author3,
    author: "claretta mason",
    price: 55,
  },
  {
    id: 4,
    courseImg: Course4,
    track: "Development",
    likes: "32.7k+",
    title: "introduction to javascript, git & GitHub",
    duration: "30hrs 50mins",
    lesson: "22 lessons",
    authorImg: Author4,
    author: "Jessica duke",
    price: 45,
  },
  {
    id: 5,
    courseImg: Course5,
    track: "Marketing",
    likes: "4.7k+",
    title: "introduction to outroom  marketing analysis",
    duration: "33hrs 50mins",
    lesson: "26 lessons",
    authorImg: Author5,
    author: "Samuel jacobs",
    price: 25,
  },
  {
    id: 6,
    courseImg: Course6,
    track: "Marketing",
    likes: "15.7k+",
    title: "introduction to live  marketing analysis",
    duration: "10hrs 50mins",
    lesson: "32 lessons",
    authorImg: Author6,
    author: "adam smith",
    price: 25,
  },
];

export const faqData = [
    {
      title: "Is there a free trial available?",
      body: "high-defination video is video of higher resolution and quality than standard definition. high-defination video is video of higher resolution and quality than standard definition. hbuild your future with our quality education. the best and largest all-in-one online tutoring platform in the worldd definition. ",
    },
    {
      title: "Can i change my plan later?",
      body: "high-defination video is video of higher resolution and quality than standard definition. high-defination video is video of higher resolution and quality than standard definition. hbuild your future with our quality education. the best and largest all-in-one online tutoring platform in the worldd definition. ",
    },
    {
      title: "Are the courses lifetime?",
      body: "high-defination video is video of higher resolution and quality than standard definition. high-defination video is video of higher resolution and quality than standard definition. hbuild your future with our quality education. the best and largest all-in-one online tutoring platform in the worldd definition. ",
    },
    {
      title: "Do i get certified after taking courses?",
      body: "high-defination video is video of higher resolution and quality than standard definition. high-defination video is video of higher resolution and quality than standard definition. hbuild your future with our quality education. the best and largest all-in-one online tutoring platform in the worldd definition. ",
    },
    {
      title: "How do i reach out to mentors?",
      body: "high-defination video is video of higher resolution and quality than standard definition. high-defination video is video of higher resolution and quality than standard definition. hbuild your future with our quality education. the best and largest all-in-one online tutoring platform in the worldd definition. ",
    },
    {
      title: "Do we get job ready after taking courses?",
      body: "high-defination video is video of higher resolution and quality than standard definition. high-defination video is video of higher resolution and quality than standard definition. hbuild your future with our quality education. the best and largest all-in-one online tutoring platform in the worldd definition. ",
    },
  ];
